import React from 'react';
import { equals, isNil } from 'ramda';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Select from 'sharedComponents/Select';
import { WEEKLY_MAX_CONNECTIONS_OPTIONS, DAILY_MAX_CONNECTIONS_OPTIONS } from 'presenters/UserPresenter';
import { Typography } from '@material-ui/core';

import useStyles from './useStyles';

const NO_MAX = 'no_max';

const Budget = props => {
  const { dailyMaxConnectionsCount, weeklyMaxConnectionsCount, onChange, isLoading } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const handleChange = ({ target: { name, value } }) => {
    const newValue = equals(NO_MAX, value) ? null : value;
    onChange({ [name]: newValue });
  };

  const weeklyConnectionsDefaultValue = isNil(weeklyMaxConnectionsCount) ? NO_MAX : weeklyMaxConnectionsCount;
  const dailyConnectionsDefaultValue = isNil(dailyMaxConnectionsCount) ? NO_MAX : dailyMaxConnectionsCount;

  return (
    <div>
      <Typography variant="h2" className={classes.header}>
        {t('components.SubscriptionPage.Budget.header')}
      </Typography>
      <Typography variant="subtitle1" color="secondary" className={classes.fieldLabel}>
        {t('components.SubscriptionPage.Budget.weeklyMaxConnections')}
      </Typography>
      <Select
        name="weeklyMaxConnectionsCount"
        fullWidth
        className={classes.select}
        formControlClassName={classes.selectForm}
        placeholder={t('components.SubscriptionPage.Budget.weeklyMaxConnections')}
        options={WEEKLY_MAX_CONNECTIONS_OPTIONS}
        onChange={handleChange}
        disabled={isLoading}
        defaultOptionValue={weeklyConnectionsDefaultValue}
      />
      <Typography variant="subtitle1" color="secondary" className={classes.fieldLabel}>
        {t('components.SubscriptionPage.Budget.dailyMaxConnections')}
      </Typography>
      <Select
        name="dailyMaxConnectionsCount"
        fullWidth
        className={classes.select}
        formControlClassName={classes.selectForm}
        placeholder={t('components.SubscriptionPage.Budget.dailyMaxConnections')}
        options={DAILY_MAX_CONNECTIONS_OPTIONS}
        onChange={handleChange}
        disabled={isLoading}
        defaultOptionValue={dailyConnectionsDefaultValue}
      />
      <Typography variant="body1" className={classes.description}>
        {t('components.SubscriptionPage.Budget.description')}
      </Typography>
    </div>
  );
};

Budget.propTypes = {
  dailyMaxConnectionsCount: PropTypes.number,
  weeklyMaxConnectionsCount: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

Budget.defaultProps = {
  dailyMaxConnectionsCount: null,
  weeklyMaxConnectionsCount: null,
};

export default Budget;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/SubscriptionPage/components/Budget/Budget.js